/* CURRENTLY USING
import React from 'react';
//import LoginRegister from './components/LoginRegister/LoginRegister';
import LoginRegister from './components/LoginRegister/login_register';

function App() {
  return <LoginRegister loginUser={null} onLoginUserChange={() => {}} />;
}

export default App;
*/

/*
// root App component that defines the main layout and routes
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';

function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
    </Routes>
  );
}

export default App;
*/
// root App component that defines the main layout and routes; react router version 5 syntax
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch, useHistory } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import HomePage from './pages/HomePage';
import Page1 from './pages/Page1';
import Page2 from './pages/Page2';
import Page3 from './pages/Page3';
import Page4 from './pages/Page4';
import Page5 from './pages/Page5';
import ProfilePage from './pages/ProfilePage';
import ViewProfile from './pages/ViewProfile';
import Page2SubPageA from './pages/Page2SubPageA';
import Page2SubPageB from './pages/Page2SubPageB';
import Page2SubPageC from './pages/Page2SubPageC';
import Page2SubPageD from './pages/Page2SubPageD';
import Page2SubPageE from './pages/Page2SubPageE';
import Page2SubPageF from './pages/Page2SubPageF';

import Page1SubPageA from './pages/Page1SubPageA';
import Page1SubPageB from './pages/Page1SubPageB';
import Page1SubPageC from './pages/Page1SubPageC';
import Page1SubPageD from './pages/Page1SubPageD';
import Page1SubPageE from './pages/Page1SubPageE';

import PostsCommentsPage from './pages/PostsCommentsPage';
import MainSocialCommentsPage from './pages/MainSocialCommentsPage';
import MainSocialCommentsReplyPage from './pages/MainSocialCommentsReplyPage';

import Page1SubPageCa from './pages/Page1SubPageCa';
import Page1SubPageCb from './pages/Page1SubPageCb';
import Page1SubPageCc from './pages/Page1SubPageCc';

import TopicPage from './pages/TopicPage';

import Page2SubPageB1a from './pages/Page2SubPageB1a';
import Page2SubPageB1b from './pages/Page2SubPageB1b';
import Page2SubPageB1c from './pages/Page2SubPageB1c';

import Page2SubPageB1 from './pages/Page2SubPageB1';
import Page2SubPageB2 from './pages/Page2SubPageB2';
import Page2SubPageB3 from './pages/Page2SubPageB3';

import BillCommentsPage from './pages/BillCommentsPage'

import Page2SubPageC1 from './pages/Page2SubPageC1';
import Page2SubPageC2 from './pages/Page2SubPageC2';
import Page2SubPageC3 from './pages/Page2SubPageC3';
import Page2SubPageC4 from './pages/Page2SubPageC4';

import SubTopicPage from './pages/SubTopicPage';

//import Page4SubPageA from './pages/Page4SubPageA';
import Page4SubPageB from './pages/Page4SubPageB';

import Page4SubPageA1 from './pages/Page4SubPageA1';
import Page4SubPageA2 from './pages/Page4SubPageA2';
import Page4SubPageA3 from './pages/Page4SubPageA3';

import Page4SubPageB1 from './pages/Page4SubPageB1';
import Page4SubPageB2 from './pages/Page4SubPageB2';
import Page4SubPageB3 from './pages/Page4SubPageB3';

import ReadingPage from './pages/ReadingPage';

import AcademicSubjectsPage from './pages/AcademicSubjectsPage';

import TopicThreadsPage from './pages/TopicThreadsPage';

import DirectMessagePage from './pages/DirectMessagePage';
import NotificationsPage from './pages/NotificationsPage';

import VideoCommentsReplyPage from './pages/VideoCommentsReplyPage';
import VideosFollowingPage from './pages/VideosFollowingPage';
import Videos from './pages/Videos';
import PhotoCommentsReplyPage from './pages/PhotoCommentsReplyPage';
import Photos from './pages/Photos';
import AudioVisualMedia from './pages/AudioVisualMedia';
import PhotosFollowingPage from './pages/PhotosFollowingPage';
import PhotosCommentsPage from './pages/PhotosCommentsPage';
import VideosCommentsPage from './pages/VideosCommentsPage';
import PhotosPopularPage from './pages/PhotosPopularPage';
import VideosPopularPage from './pages/VideosPopularPage';
//import ReadingPage2 from './pages/ReadingPage2';
import CommentsReplyPage from './pages/CommentsReplyPage';
import SupremeCourtCasesPage from './pages/SupremeCourtCasesPage';
import ScotusCommentsPage from './pages/ScotusCommentsPage';
import ScotusCommentsReplyPage from './pages/ScotusCommentsReplyPage';
import CaliforniaBillsPage from './pages/CaliforniaBillsPage';
import CaliforniaBillCommentsPage from './pages/CaliforniaBillCommentsPage';
import CaliforniaBillCommentsReplyPage from './pages/CaliforniaBillCommentsReplyPage';
import CaliforniaPropositionsPage from './pages/CaliforniaPropositionsPage';
import CaliforniaPropCommentsPage from './pages/CaliforniaPropCommentsPage';
import CaliforniaPropCommentsReplyPage from './pages/CaliforniaPropCommentsReplyPage';

import GubernatorialElections from './pages/GubernatorialElections';
import GubernatorialElectionsCommentsPage from './pages/GubernatorialElectionsCommentsPage';
import GubernatorialElectionsCommentsReplyPage from './pages/GubernatorialElectionsCommentsReplyPage';

import USHouseOfRepElections from './pages/USHouseOfRepElections';
import USHouseOfRepElectionsCommentsPage from './pages/USHouseOfRepElectionsCommentsPage';
import USHouseOfRepElectionsCommentsReplyPage from './pages/USHouseOfRepElectionsCommentsReplyPage';

import USSenateElections from './pages/USSenateElections';
import USSenateElectionsCommentsPage from './pages/USSenateElectionsCommentsPage';
import USSenateElectionsCommentsReplyPage from './pages/USSenateElectionsCommentsReplyPage';

import StatewideOfficesElections from './pages/StatewideOfficesElections';
import StatewideOfficesElectionsCommentsPage from './pages/StatewideOfficesElectionsCommentsPage';
import StatewideOfficesElectionsCommentsReplyPage from './pages/StatewideOfficesElectionsCommentsReplyPage';

import StateLegislatureElections from './pages/StateLegislatureElections';
import StateLegislatureElectionsCommentsPage from './pages/StateLegislatureElectionsCommentsPage';
import StateLegislatureElectionsCommentsReplyPage from './pages/StateLegislatureElectionsCommentsReplyPage';

import GovPostCommentsPage from './pages/GovPostCommentsPage';
import GovPostCommentsReplyPage from './pages/GovPostCommentsReplyPage';

import VerifyEmail from "./pages/VerifyEmail";
import Contact from "./pages/Contact";
import AboutPage from "./pages/AboutPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import SupportPage from "./pages/SupportPage";
import CareersPage from "./pages/CareersPage";

import axios from 'axios';

axios.defaults.baseURL = process.env.REACT_APP_API_URL;
axios.defaults.withCredentials = true;

import { Analytics } from "@vercel/analytics/react";

import DevLoginPage from './pages/DevLoginPage';
// ─── Blocks everything unless dev gate is passed ───────────
function DevRoute({ children }) {
  const [loading, setLoading] = React.useState(true);
  const [allowed, setAllowed] = React.useState(false);
  const history = useHistory();

  useEffect(() => {
    //fetch("/api/dev-me", { credentials: "include" })
    fetch(`${process.env.REACT_APP_API_URL}/api/dev-me`, {
      credentials: "include"
    })
      .then(res => {
        if (res.ok) setAllowed(true);
        else history.push("/dev-login");
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) return null;
  return allowed ? children : null;
}

// ─── Blocks app pages unless fully logged in ───────────────
function ProtectedRoute({ children }) {
  const [loading, setLoading] = React.useState(true);
  const [allowed, setAllowed] = React.useState(false);
  const history = useHistory();

  useEffect(() => {
    fetch("/api/me", { credentials: "include" })
      .then(res => {
        if (res.ok) setAllowed(true);
        else history.push("/login");       // → your app's login page
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) return null;
  return allowed ? children : null;
}

function App() {
  return (
    <>
    <Router>
      <Switch>

        {/* Your private dev login page — no protection, you need to reach it */}
        {/*<Route path="/dev-login" component={DevLoginPage} />*/}

        {/* Email verification must stay public */}
        <Route
          path="/verify-email"
          component={VerifyEmail}
        />

        {/* Everything else is behind the dev gate */}
        <Route path="/">
          {/*<DevRoute>*/}

      <Switch>
        <Route exact path="/" component={LandingPage} />
        <Route path="/login" component={LoginPage} />
        <Route path="/register" component={RegisterPage} />
        <Route path="/about" component={AboutPage} />
        <Route path="/terms" component={TermsPage} />
        <Route path="/privacy" component={PrivacyPage} />
        <Route path="/support" component={SupportPage} />
        <Route path="/careers" component={CareersPage} />
        <Route path="/contact" component={Contact} />
        <Route path="/home" component={HomePage} /> 
        {/*<Route path="/post/:postId/comments" component={PostsCommentsPage} />*/}
        <Route path="/mainSocial/:id/comments/:commentId" component={MainSocialCommentsReplyPage} />
        <Route path="/post/:id/comments" component={MainSocialCommentsPage} />
        <Route path="/mainsocial/popular" component={Page1SubPageA} />
        <Route path="/mainsocial/following" component={Page1SubPageB} />

        {/*
        <Route path="/page1/c/subPage1Ca" component={Page1SubPageCa} />
        <Route path="/page1/c/subPage1Cb" component={Page1SubPageCb} />
        <Route exact path="/page1/c" component={Page1SubPageC} />
        */}
        <Route path="/mainsocial/academia/university/:mainTopic/:subTopicType/:subtopic" component={SubTopicPage} />
        <Route path="/mainsocial/academia/university/:topicName" component={TopicPage} />
        <Route path="/mainsocial/topicthreads/:topicThread" component={TopicThreadsPage} />
        <Route path="/mainsocial/academia/academicsubjects/:academicTopic" component={AcademicSubjectsPage} />
        <Route path="/mainsocial/academia/popular" component={Page1SubPageCa} />
        <Route path="/mainsocial/academia/university" component={Page1SubPageCb} />
        <Route path="/mainsocial/academia/academicsubjects" component={Page1SubPageCc} />
        <Route exact path="/page1/c" component={Page1SubPageC} />

        <Route path="/mainsocial/topicthreads" component={Page1SubPageD} />
        <Route path="/page1/e" component={Page1SubPageE} />
        <Route path="/page1" component={Page1} />
        <Route path="/page2/a" component={Page2SubPageA} />
        
        <Route path="/calProp/:id/comments/:commentId" component={CaliforniaPropCommentsReplyPage} />
        <Route path="/calProp/:id/comments" component={CaliforniaPropCommentsPage} />
        <Route path="/page2/CaliforniaPropositions" component={CaliforniaPropositionsPage} />

        <Route path="/calBill/:id/comments/:commentId" component={CaliforniaBillCommentsReplyPage} />
        <Route path="/calBill/:id/comments" component={CaliforniaBillCommentsPage} />
        <Route path="/Government/StateBills" component={CaliforniaBillsPage} />

        <Route path="/scotusCase/:id/comments/:commentId" component={ScotusCommentsReplyPage} />
        <Route path="/scotusCase/:id/comments" component={ScotusCommentsPage} />
        <Route path="/Government/SupremeCourt" component={SupremeCourtCasesPage} />

        {/*<Route path="/commentReplies/:commentId" component={CommentsReplyPage} />*/}
        <Route path="/bill/:id/comments/:commentId" component={CommentsReplyPage} />
        <Route path="/bill/:id/comments" component={BillCommentsPage} />
        <Route path="/page2/b/b1/a" component={Page2SubPageB1a} />
        <Route path="/page2/b/b1/b" component={Page2SubPageB1b} />
        <Route path="/page2/b/b1/c" component={Page2SubPageB1c} />

        <Route path="/page2/b/b1" component={Page2SubPageB1} />
        <Route path="/Government/CongressionalBills" component={Page2SubPageB2} />
        <Route path="/page2/b/b3" component={Page2SubPageB3} />
        <Route path="/page2/b" component={Page2SubPageB} />

        <Route path="/page2/c1" component={Page2SubPageC1} />
        <Route path="/page2/c2" component={Page2SubPageC2} />
        <Route path="/page2/c3" component={Page2SubPageC3} />
        <Route path="/page2/c4" component={Page2SubPageC4} />
        <Route path="/page2/c" component={Page2SubPageC} />

        <Route path="/Government/Elections/StateLegislatureElections/:id/comments/:commentId" component={StateLegislatureElectionsCommentsReplyPage} />
        <Route path="/Government/Elections/StateLegislatureElections/:id/comments" component={StateLegislatureElectionsCommentsPage} />
        <Route path="/Government/Elections/StateLegislatureElections" component={StateLegislatureElections} />

        <Route path="/Government/Elections/StatewideOfficesElections/:id/comments/:commentId" component={StatewideOfficesElectionsCommentsReplyPage} />
        <Route path="/Government/Elections/StatewideOfficesElections/:id/comments" component={StatewideOfficesElectionsCommentsPage} />
        <Route path="/Government/Elections/StatewideOfficesElections" component={StatewideOfficesElections} />

        <Route path="/Government/Elections/USSenateElections/:id/comments/:commentId" component={USSenateElectionsCommentsReplyPage} />
        <Route path="/Government/Elections/USSenateElections/:id/comments" component={USSenateElectionsCommentsPage} />
        <Route path="/Government/Elections/USSenateElections" component={USSenateElections} />

        <Route path="/Government/Elections/USHouseOfRepElections/:id/comments/:commentId" component={USHouseOfRepElectionsCommentsReplyPage} />
        <Route path="/Government/Elections/USHouseOfRepElections/:id/comments" component={USHouseOfRepElectionsCommentsPage} />
        <Route path="/Government/Elections/USHouseOfRepresentativesElections" component={USHouseOfRepElections} />

        <Route path="/Government/Elections/GubernatorialElections/:id/comments/:commentId" component={GubernatorialElectionsCommentsReplyPage} />
        <Route path="/Government/Elections/GubernatorialElections/:id/comments" component={GubernatorialElectionsCommentsPage} />
        <Route path="/Government/Elections/GubernatorialElections" component={GubernatorialElections} />

        <Route path="/govPost/:id/comments/:commentId" component={GovPostCommentsReplyPage} />
        <Route path="/govPost/:id/comments" component={GovPostCommentsPage} />
        
        {/*<Route path="/page2/d" component={Page2SubPageD} />*/}
        <Route path="/Government/:mode" component={Page2SubPageD} />
        <Route path="/page2/e" component={Page2SubPageE} />
        <Route path="/page2/f" component={Page2SubPageF} />
        <Route path="/page2" component={Page2} />
        <Route path="/page3" component={Page3} />

        {/*<Route path="/ReadingPage2" component={ReadingPage2} />*/}
        <Route path="/books/read/:id" component={ReadingPage} />
        <Route path="/page4/a1" component={Page4SubPageA1} />
        <Route path="/page4/a2" component={Page4SubPageA2} />
        <Route path="/page4/a3" component={Page4SubPageA3} />
        {/*<Route path="/page4/a" component={Page4SubPageA} />*/}
        <Route path="/page4/b1" component={Page4SubPageB1} />
        <Route path="/page4/b2" component={Page4SubPageB2} />
        <Route path="/page4/b3" component={Page4SubPageB3} />
        <Route path="/page4/b" component={Page4SubPageB} />
        <Route path="/page4" component={Page4} />

        <Route path="/video/:id/comments/:commentId" component={VideoCommentsReplyPage} />
        <Route path="/videos/:postId/comments" component={VideosCommentsPage} />
        <Route path="/mainsocial/videos/following" component={VideosFollowingPage} />
        <Route path="/mainsocial/videos/popular" component={VideosPopularPage} />
        <Route path="/photo/:id/comments/:commentId" component={PhotoCommentsReplyPage} />
        <Route path="/photos/:postId/comments" component={PhotosCommentsPage} />
        <Route path="/mainsocial/photos/following" component={PhotosFollowingPage} />
        <Route path="/mainsocial/photos/popular" component={PhotosPopularPage} />
        <Route path="/photos" component={Photos} />
        <Route path="/videos" component={Videos} />
        <Route path="/audiovisual" component={AudioVisualMedia} />
        <Route path="/page5" component={Page5} />
        <Route path="/profile" component={ProfilePage} />
        <Route path="/notificationsPage" component={NotificationsPage} />
        <Route path="/directmessage" component={DirectMessagePage} />
        { /* <Route path="/profile/:userId" component={ViewProfile} /> */}
        <Route path="/user/view/:userId" component={ViewProfile} />
      </Switch>
    {/*</DevRoute>*/}
        </Route>

      </Switch>
    </Router>
    <Analytics />
    </>
  );
}

export default App;